/**
 * ADR-220 §7 — the in-app due reminder on the web (owner choice 6), mirror of
 * the app's ReminderCardHost. Signed-in customers only. The engagement rule
 * (eros-reminder-rules.js) lives across page loads in sessionStorage; when it
 * passes, one GET /v1/reminder/next per 6 hours claims the need, and the card
 * floats over the header. `shown` is sent after 3 s on screen (or a click);
 * a card that leaves earlier is released so Desk keeps the need. The server
 * answers 204 until Desk marks needs eligible, which is the switch.
 */
(function () {
  'use strict';

  var R = window.ErosReminderRules;
  var Reco = window.ErosRecoRules;
  if (!R || !Reco) return;

  var STATE_KEY = 'eros_reminder_engagement_v1';
  var ASK_KEY = 'eros_reminder_last_ask_v1';
  var ASK_INTERVAL_MS = 6 * 3600 * 1000;
  var DWELL_MS = 3000;
  var HEARTBEAT_MS = 60000;
  /* Off until the card is verified live with Desk's data (same gate as the
     app's Remote Config `reminder_enabled`); flip and republish this file. */
  var ENABLED = false;
  var cfg = R.config({ enabled: ENABLED });

  function t(key, fallback) {
    var s = (window.themeVariables && window.themeVariables.strings) || {};
    return s[key] || fallback;
  }

  function loadState() {
    try {
      var raw = JSON.parse(window.sessionStorage.getItem(STATE_KEY) || 'null');
      if (raw && typeof raw.sessionStart === 'number') return raw;
    } catch (e) {
      /* fall through */
    }
    return R.coldStart(Date.now());
  }

  var state = loadState();
  function save() {
    try {
      window.sessionStorage.setItem(STATE_KEY, JSON.stringify(state));
    } catch (e) {
      /* ignore */
    }
  }
  function apply(change) {
    state = change(state);
    save();
    schedule();
  }

  function meta() {
    return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
  }

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- the card ---------- */

  var showing = null; // { card, variantId, handle, el, ack, timers: [] }

  function report(card, type) {
    return window.ErosCommerce.request('/v1/reminder/event', {
      method: 'POST',
      auth: true,
      body: { need_key: card.need_key, anchor: card.anchor, claim: card.claim, type: type }
    }).then(function (res) { return !!(res && res.dup); }).catch(function () { return false; });
  }

  function hide() {
    var s = showing;
    if (!s) return;
    showing = null;
    s.timers.forEach(clearTimeout);
    clearInterval(s.heartbeat);
    if (!s.ack) report(s.card, 'release');
    s.el.classList.remove('is-visible');
    setTimeout(function () { s.el.remove(); }, 240);
  }

  function interact(type) {
    var s = showing;
    if (!s) return null;
    s.ack = true;
    clearInterval(s.heartbeat);
    report(s.card, type);
    return s;
  }

  function button(cls, label, svgPath) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'eros-reminder__button ' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="' + svgPath + '"/></svg>';
    return b;
  }

  function show(card, product) {
    var el = document.createElement('div');
    el.className = 'eros-reminder';
    el.setAttribute('role', 'status');
    var img = document.createElement('img');
    img.className = 'eros-reminder__image';
    img.alt = '';
    if (product.image) img.src = product.image;
    var text = document.createElement('div');
    text.className = 'eros-reminder__text';
    var title = document.createElement('p');
    title.className = 'eros-reminder__title';
    title.textContent = product.title;
    var caption = document.createElement('p');
    caption.className = 'eros-reminder__caption';
    caption.textContent = t('erosReminderCaption', 'حان وقت شرائه');
    text.append(title, caption);
    var add = button('eros-reminder__button--add', t('erosReminderAdd', 'إضافة للسلّة'), 'M12 5v14M5 12h14');
    var close = button('', t('erosReminderClose', 'إغلاق التذكير'), 'M6 6l12 12M18 6L6 18');
    el.append(img, text, add, close);
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });

    showing = { card: card, variantId: product.variantId, handle: product.handle, el: el, ack: false, timers: [] };
    apply(R.cardShown);
    showing.timers.push(setTimeout(function () {
      var s = showing;
      if (!s || s.ack) return;
      s.ack = true;
      clearInterval(s.heartbeat);
      report(s.card, 'shown').then(function (dup) { if (dup && showing === s) hide(); });
    }, DWELL_MS));
    showing.heartbeat = setInterval(function () {
      if (showing && !showing.ack) report(showing.card, 'heartbeat');
    }, HEARTBEAT_MS);

    close.addEventListener('click', function (e) {
      e.stopPropagation();
      if (interact('dismissed')) hide();
    });
    add.addEventListener('click', function (e) {
      e.stopPropagation();
      var s = interact('added');
      if (!s) return;
      fetch(routesRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(s.variantId), quantity: 1 }] })
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        title.textContent = t('erosReminderAdded', 'أُضيف إلى سلتك');
        caption.remove();
        add.remove();
        close.remove();
        s.timers.push(setTimeout(hide, 1500));
      }).catch(hide);
    });
    el.addEventListener('click', function () {
      var s = interact('opened');
      if (!s) return;
      hide();
      window.location.href = routesRoot() + 'products/' + encodeURIComponent(s.handle);
    });
  }

  /** The card's exact variant (then the alternates), live from the storefront. */
  function resolveProduct(card, cartVariantIds) {
    var candidates = [{ product_gid: card.product_gid, variant_gid: card.variant_gid }].concat(card.alternates || []);
    var onScreen = meta().product ? Reco.productGid(meta().product.id) : null;
    function tryAt(i) {
      if (i >= candidates.length) return Promise.resolve(null);
      var c = candidates[i];
      var variantId = (/(\d+)$/.exec(c.variant_gid) || [])[1];
      if (!variantId || cartVariantIds.indexOf(Number(variantId)) >= 0 || c.product_gid === onScreen) return tryAt(i + 1);
      var url = routesRoot() + 'search?type=product&q=' + encodeURIComponent(Reco.searchQuery([c.product_gid])) + '&section_id=eros-reco-cards';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cardEl = doc.querySelector('[data-eros-reco-card]');
          var handle = cardEl && cardEl.getAttribute('data-product-handle');
          if (!handle) return tryAt(i + 1);
          return fetch(routesRoot() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (p) {
              var v = (p.variants || []).filter(function (x) { return String(x.id) === variantId; })[0];
              if (!v || !v.available) return tryAt(i + 1);
              var image = (v.featured_image && v.featured_image.src) || p.featured_image || '';
              return { variantId: variantId, handle: handle, title: p.title, image: image };
            });
        })
        .catch(function () { return tryAt(i + 1); });
    }
    return tryAt(0);
  }

  var asking = false;
  function ask() {
    if (asking || showing) return;
    if (!window.ErosSession || !window.ErosSession.isSignedIn()) return;
    var last = 0;
    try {
      last = Number(window.localStorage.getItem(ASK_KEY) || 0);
    } catch (e) {
      /* ignore */
    }
    if (Date.now() - last < ASK_INTERVAL_MS) return;
    asking = true;
    try {
      window.localStorage.setItem(ASK_KEY, String(Date.now()));
    } catch (e) {
      /* ignore */
    }
    window.ErosCommerce.request('/v1/reminder/next?platform=web', { auth: true })
      .then(function (card) {
        if (!card || !card.need_key) return null;
        return fetch(routesRoot() + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .catch(function () { return { items: [] }; })
          .then(function (cart) {
            var ids = (cart.items || []).map(function (i) { return i.variant_id; });
            return resolveProduct(card, ids).then(function (product) {
              if (!product || !R.mayRemind(state, Date.now(), cfg)) return report(card, 'release');
              show(card, product);
            });
          });
      })
      .catch(function () { /* 204 or offline: nothing this time */ })
      .then(function () { asking = false; });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    var now = Date.now();
    if (R.mayRemind(state, now, cfg)) return ask();
    var next = R.nextCheckAt(state, cfg);
    if (next !== null && next > now) timer = setTimeout(schedule, next - now);
  }

  /* ---------- engagement events ---------- */

  function boot() {
    var m = meta();
    var pageType = (m.page && m.page.pageType) || '';
    apply(function (s) { return R.screenChanged(s, R.screenFor(pageType, location.pathname), Date.now()); });
    if (pageType === 'product') apply(R.productOpened);
    if (pageType === 'searchresults') apply(R.searched);
    document.addEventListener('variant:add', function () { apply(R.addedToCart); });
    document.addEventListener('cart:change', function (e) {
      var base = e.detail && e.detail.baseEvent;
      if (base === 'eros:listing-quick-add' || base === 'eros:pdp-cart-stepper') apply(R.addedToCart);
    });
    document.addEventListener('dialog:after-show', function () { apply(function (s) { return R.overlayChanged(s, true); }); });
    document.addEventListener('dialog:after-hide', function () { apply(function (s) { return R.overlayChanged(s, false); }); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        apply(function (s) { return R.backgrounded(s, Date.now()); });
        hide();
      } else {
        apply(function (s) { return R.resumed(s, Date.now(), cfg); });
      }
    });
    window.addEventListener('pagehide', hide);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
